import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './index.less';

const HEADER_DATA = [
  {
    name: 'SUPPLIER',
    path: 'https://www.dsers.com/developers/supplier-app/',
    blank: true,
  },
  {
    name: 'SALES CHANNEL',
    path: 'https://www.dsers.com/developers/channel-app/',
    blank: true,
  },
  {
    name: 'API Introduction',
    path: '/pricing/',
    childrens: [
      {
        name: 'Overview',
        path: 'https://www.dsers.com/developers/api-overview/',
        blank: true,
      },
      {
        name: 'Auth Service',
        path: '/auth_service',
        blank: true,
      },
      {
        name: 'Channel APP',
        path: '/api/channel_app_api',
        blank: true,
      },
      {
        name: 'Middle Platform For Channel APP',
        path: '/api/channel_middle_platform_api',
        blank: true,
      },
      {
        name: 'Supplier APP',
        path: '/api/supplier_app_api',
        blank: true,
      },
      {
        name: 'Middle Platform For Supplier APP',
        path: '/api/supplier_middle_platform_api',
        blank: true,
      },
      {
        name: 'Status And Error Codes',
        path: '/status_and_error_codes',
        blank: true,
      },
    ],
  },
];

const NavDropdown = ({ item }) => (
  <div className="nav-item dropdown" style={{ textTransform: 'uppercase' }}>
    {item.name}
    <div className="nav-dropdown">
      <ul className="childrens">
        {item?.childrens?.map((itemKey, index) => (
          <li key={index}>
            {itemKey.blank ? (
              <div className="childrens_hover" style={{ textTransform: 'uppercase' }}>
                <a href={itemKey.path} target="_blank" rel="noreferrer">
                  {itemKey.name}
                </a>
              </div>
            ) : (
              <div className="childrens_hover" style={{ textTransform: 'uppercase' }}>
                <Link to={itemKey.path}>{itemKey.name}</Link>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const ClassicHeader = ({ origin, isApiReview }) => (
  <div className="header_container">
    <div className="header" style={isApiReview ? { width: '100%', padding: '0 32px' } : null}>
      <div className="header_box">
        <Link to="/" className="logo">
          <img src="https://img.dsers.com/dsevs_dev/Logo.svg" alt="DSers logo" />
        </Link>
        <ul className="ul" style={isApiReview ? { marginLeft: '150px' } : null}>
          {HEADER_DATA.map((item, i) => (
            <li key={i}>
              {item?.childrens ? (
                <NavDropdown item={item} />
              ) : (
                <Link
                  className="nav-item"
                  to={item.path}
                  target="_blank"
                  style={{ textTransform: 'uppercase' }}
                >
                  {item.name}
                </Link>
              )}
            </li>
          ))}
        </ul>
        <div className="login_box">
          <a className="try_it_free header_register" href={`${origin}/accounts/login?from=dev`}>
            LOGIN
          </a>
          <a href={`${origin}/accounts/register?from=dev`} className="login header_login">
            CREATE ACCOUNT
          </a>
        </div>
      </div>
    </div>
  </div>
);

const HomeHeader = ({ origin }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setMenuOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  const scrollToSection = (id) => (event) => {
    event.preventDefault();
    closeMenu();

    const target = document.getElementById(id);
    if (!target) return;

    const header = document.querySelector('.site-header');
    const offset = (header?.offsetHeight || 72) + 24;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    window.history.replaceState(null, '', `#${id}`);

    document.querySelectorAll('.app-card.is-targeted').forEach((el) => {
      el.classList.remove('is-targeted');
    });
    if (target.classList.contains('app-card')) {
      target.classList.add('is-targeted');
      window.setTimeout(() => target.classList.remove('is-targeted'), 1800);
    }
  };

  return (
    <header className="site-header">
      <div className="site-header__shell">
        <Link to="/" className="site-brand" aria-label="DSers developer home" onClick={closeMenu}>
          <img
            className="site-brand__logo"
            src="/home/dsers-logo.avif"
            width="104"
            height="36"
            alt="DSers"
          />
          <span className="site-brand__dev">.dev</span>
        </Link>

        <nav className="site-header__desktop" aria-label="Page navigation">
          <a href="#supplier-app" onClick={scrollToSection('supplier-app')}>
            Supplier
          </a>
          <a href="#channel-app" onClick={scrollToSection('channel-app')}>
            Sales Channel
          </a>
          <Link to="/api/supplier_middle_platform_api">API Introduction</Link>
        </nav>

        <div className="site-header__actions">
          <a className="site-header__login" href={`${origin}/accounts/login?from=dev`}>
            LOG IN
          </a>
          <a className="site-header__cta" href={`${origin}/accounts/register?from=dev`}>
            CREATE ACCOUNT
          </a>
          <button
            className="site-header__menu-toggle"
            type="button"
            aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-controls="mobile-menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
          </button>
        </div>
      </div>

      <nav
        id="mobile-menu"
        className="site-header__mobile"
        aria-label="Mobile navigation"
        data-open={menuOpen}
      >
        <a href="#supplier-app" onClick={scrollToSection('supplier-app')}>
          Supplier
        </a>
        <a href="#channel-app" onClick={scrollToSection('channel-app')}>
          Sales Channel
        </a>
        <Link to="/api/supplier_middle_platform_api" onClick={closeMenu}>
          API Introduction
        </Link>
        <a href={`${origin}/accounts/login?from=dev`} onClick={closeMenu}>
          LOG IN
        </a>
        <a
          className="site-header__mobile-primary"
          href={`${origin}/accounts/register?from=dev`}
          onClick={closeMenu}
        >
          CREATE DEVELOPER ACCOUNT
        </a>
      </nav>
    </header>
  );
};

export const Header = () => {
  const origin = process.env.REACT_APP_DSERS_USER_CENTER_ORIGIN;
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isApiReview = location.hash.includes('#/');

  if (isHome) {
    return <HomeHeader origin={origin} />;
  }

  return <ClassicHeader origin={origin} isApiReview={isApiReview} />;
};
